@if (label()) {
    <form-label [id]="id() + '-label'" [forId]="id()" [label]="label() || ''"></form-label>
}
<p-multiSelect
    [inputId]="id()"
    [optionLabel]="'name'"
    [optionValue]="'feeWaiverId'"
    [options]="feeWaiversOptions()"
    [ngModel]="value()"
    [showClear]="true"
    [fluid]="true"
    [size]="'large'"
    [disabled]="disabled()"
    [placeholder]="placeholder() | translate"
    (ngModelChange)="value.set($event || [])"
    (onChange)="onChange.emit($event.value || [])"
    (onClear)="onClear.emit()">
    <ng-template let-waiver #item>
        <fee-waiver-tag [feeWaiver]="waiver" [enableAuditLog]="false"></fee-waiver-tag>
    </ng-template>

    <ng-template let-selected #selecteditems>
        @let maxSelected = maxSelectedLabels();
        @let selectedList = selected || [];
        @if (selectedList.length) {
            @if (!maxSelected || selectedList.length < maxSelected) {
                <div class="multiselect-waiver-labels-container" [class.truncate]="truncateSelectedLabels()">
                    <span class="multiselect-waiver-labels-line">
                        @for (waiver of selectedList; track waiver.feeWaiverId) {
                            <fee-waiver-tag
                                [feeWaiver]="waiver"
                                [isRemovable]="true"
                                [shouldStopPropagation]="shouldStopPropagation()"
                                [enableAuditLog]="false"
                                (onRemove)="onRemove.emit(waiver.feeWaiverId)"></fee-waiver-tag>
                        }
                    </span>
                </div>
            } @else if (selectedCountLabel() && maxSelected && selectedList.length >= maxSelected) {
                <span>{{ selectedCountLabel() || '' | translate: { count: selectedList.length } }}</span>
            }
        }
    </ng-template>
</p-multiSelect>
